import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_reasons-insured",
  "use": "svg_reasons-insured-usage",
  "viewBox": "0 0 42 49",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 42 49\" id=\"svg_reasons-insured\"><path d=\"m19.122 27.937-7.67-7.67 2.05-2.104 5.567 5.593L29.72 13.103l2.105 2.104-12.704 12.73ZM41.946.107v15.979c0 13.023-8.256 24.608-20.986 31.958C8.175 40.587 0 29.002 0 15.98V0l41.946.107Zm-3.01 2.982H2.983v12.89c0 11 6.525 21.306 17.976 28.55 11.452-7.217 17.977-17.55 17.977-28.55V3.09Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol